import { render } from "./MyContactorView.vue?vue&type=template&id=6506f71e&scoped=true"
import script from "./MyContactorView.vue?vue&type=script&lang=js"
export * from "./MyContactorView.vue?vue&type=script&lang=js"

import "./MyContactorView.vue?vue&type=style&index=0&id=6506f71e&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6506f71e"]])

export default __exports__